define('viewModels/privileged/callbacks/ScheduledCallbackActions',[
    'lib/bluebird',
    'lib/knockout',
    'lib/lodash4',
    'services/apiCore',
    'services/authService',
    'services/featureToggleService',
    'services/toastService',
    'viewModels/ViewModel'
], function (
    Promise,
    ko,
    _,
    apiCore,
    authService,
    featureToggleService,
    toastService,
    ViewModel
) {
    'use strict';

    var MAX_ATTEMPTS = 10;
    var ONE_SECOND = 1000;
    var EXTERNAL_PARTICIPANT_PURPOSES = [
        'customer',
        'external',
        'user'
    ];

    return ViewModel.extend(function (scheduledCallbacks, analyticsConversation) {
        var self = this;

        self.canCancel = !featureToggleService.getFeatureToggle('authorization.division.management')() ?
            authService.hasAuthorization('perm:conversation:communication:disconnect') :
            _.some(analyticsConversation.divisionIds(), function (divisionId) {
                return authService.hasAuthorization('perm:conversation:communication:disconnect:' + divisionId);
            });
        self.isCancelling = ko.observable(false);

        self.cancelScheduledCallbacks = function () {
            self.isCancelling(true);

            if (featureToggleService.getFeatureToggle('callbacks.disconnect.external.peers.only')()) {
                apiCore.v2.get('/conversations/' + analyticsConversation.conversationId())
                    .then(function (conversation) {
                        var scheduledCallbacks = [];
                        _.forEach(conversation.participants, function (participant) {
                            _.forEach(participant.callbacks, function (callback) {
                                if (_.toLower(callback.state) === 'scheduled') {
                                    callback.participant = participant;
                                    scheduledCallbacks.push(callback);
                                }
                            });
                        });

                        // attempt to find a callback on an external participant
                        var callbackToCancel = _.find(scheduledCallbacks, function (scheduledCallback) {
                            var purpose = _.toLower(scheduledCallback.participant.purpose);
                            return _.includes(EXTERNAL_PARTICIPANT_PURPOSES, purpose);
                        });

                        // if we can't find a scheduled callback on an external participant, just pick one
                        callbackToCancel = callbackToCancel || _.get(scheduledCallbacks, '0');

                        if (callbackToCancel) {
                            cancelScheduledCallback(callbackToCancel.participant.id, callbackToCancel.id)
                                .then(function () {
                                    validateDisconnected(callbackToCancel.id);
                                })
                                .catch(function () {
                                    self.isCancelling(false);
                                    toastService.notifyMajorAlert('scheduledCallbacks.actions.cancel.requestFailed');
                                });
                        }
                    });
            } else {
                apiCore.v2.patch('/conversations/callbacks/' + analyticsConversation.conversationId(), { state: 'disconnected' })
                    .then(function () {
                        validateDisconnected();
                    })
                    .catch(function () {
                        self.isCancelling(false);
                        toastService.notifyMajorAlert('scheduledCallbacks.actions.cancel.requestFailed');
                    });
            }
        };

        var cancelScheduledCallback = function (participantId, communicationId) {
            var communicationUri = '/conversations/callbacks/' + analyticsConversation.conversationId() + '/participants/' + participantId + '/communications/' + communicationId;
            return apiCore.v2.patch(communicationUri, { state: 'disconnected' });
        };

        var validateDisconnected = function (cancelledCallbackId, attempts) {
            attempts = attempts || 0;

            apiCore.v2.get('/conversations/' + analyticsConversation.conversationId())
                .then(function (conversation) {
                    var disconnected;
                    if (featureToggleService.getFeatureToggle('callbacks.disconnect.external.peers.only')()) {
                        // check if the cancelled callback is still connected
                        disconnected = !_.find(conversation.participants, function (participant) {
                            return _.find(participant.callbacks, function (callback) {
                                return cancelledCallbackId === callback.id &&
                                    _.chain(callback).get('state').toLower().value() !== 'disconnected';
                            });
                        });
                    } else {
                        disconnected = !_(conversation.participants)
                            .map(_.values).flatten()
                            .filter(_.isArray).flatten()
                            .find(function (communication) {
                                return _.chain(communication).get('state').toLower().value() === 'connected';
                            });
                    }

                    if (disconnected) {
                        self.isCancelling(false);
                        scheduledCallbacks.removeRow(analyticsConversation.conversationId());
                        toastService.notifyMessage('scheduledCallbacks.actions.cancel.succeeded');
                    } else if (attempts < MAX_ATTEMPTS) {
                        setTimeout(function () { validateDisconnected(cancelledCallbackId, ++attempts); }, ONE_SECOND);
                    } else {
                        self.isCancelling(false);
                        toastService.notifyMajorAlert('scheduledCallbacks.actions.cancel.failed');
                    }
                })
                .catch(function () {
                    if (attempts < MAX_ATTEMPTS) {
                        setTimeout(function () { validateDisconnected(cancelledCallbackId, ++attempts); }, ONE_SECOND);
                    } else {
                        self.isCancelling(false);
                        toastService.notifyMajorAlert('scheduledCallbacks.actions.cancel.validateFailed');
                    }
                });
        };
    });
});
